import type { InstalledToolsFilterableField } from '@kirin/api-client/contracts/shadow-ai-installed-tools';
import { INSTALLED_TOOLS_FILTERABLE_FIELDS } from '@kirin/api-client/contracts/account-shadow-ai-installed-tools';
import { TABLE_IDS } from '@/components/DataTable/tableIds';

type PersonalInstalledToolsFilterableField = Exclude<
  InstalledToolsFilterableField,
  | typeof INSTALLED_TOOLS_FILTERABLE_FIELDS.USERS
  // Logged-in-user is an org-only column (KIR-2916); not shown in personal view.
  | typeof INSTALLED_TOOLS_FILTERABLE_FIELDS.LOGGED_IN_USER
  // KIR-5098: endpoint filter is org-only too.
  | typeof INSTALLED_TOOLS_FILTERABLE_FIELDS.ENDPOINT
>;

export const PERSONAL_INSTALLED_TOOLS_FILTER_URL_KEYS = {
  [INSTALLED_TOOLS_FILTERABLE_FIELDS.NAME]: 'n',
  [INSTALLED_TOOLS_FILTERABLE_FIELDS.CATEGORY]: 'cat',
  [INSTALLED_TOOLS_FILTERABLE_FIELDS.RISK]: 'r',
  [INSTALLED_TOOLS_FILTERABLE_FIELDS.FIRST_DETECTED]: 'fd',
  [INSTALLED_TOOLS_FILTERABLE_FIELDS.LAST_SEEN]: 'ls',
} as const satisfies Record<PersonalInstalledToolsFilterableField, string>;

export const PERSONAL_INSTALLED_TOOLS_TABLE_CONFIG = {
  tableId: TABLE_IDS.PERSONAL.SHADOW_AI.TOOLS,
} as const;
